'use client';

import { usePathname } from 'next/navigation';
import { OpenPanelComponent } from '@openpanel/nextjs';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { GoogleTagManager } from '@next/third-parties/google';

import { isIdentitySensitiveUrl } from '@/lib/kyc/privacy';

export function RouteTelemetry({ openPanelClientId }: { openPanelClientId: string }) {
  const pathname = usePathname();
  if (isIdentitySensitiveUrl(pathname)) return null;

  return (
    <>
      {process.env.NODE_ENV !== 'development' ? <GoogleTagManager gtmId="GTM-KTFS9Q4Z" /> : null}
      {process.env.NEXT_PUBLIC_ENABLE_OPENPANEL === 'true' ? (
        <OpenPanelComponent
          apiUrl="/api/analytics"
          cdnUrl="/api/analytics/op1.js"
          clientId={openPanelClientId}
          trackScreenViews
          filter="function(payload) { return !/\/(public\/identity|admin\/cases|api\/admin\/cases)(\/|\?|$)/.test(location.pathname) && !/\/(public\/identity|admin\/cases|api\/admin\/cases)(\/|\?|$)/.test(JSON.stringify(payload)); }"
        />
      ) : null}
      <SpeedInsights
        beforeSend={(event) =>
          isIdentitySensitiveUrl(window.location.pathname) || isIdentitySensitiveUrl(event.url) ? null : event
        }
      />
    </>
  );
}
